const initState = {
  categories: [],
  topics: [],
  fileTypes: [],
  page: 1,
  limit: 10,
  count: 0,
};

const ProductAttributesReducer = (state = initState, action) => {
  switch (action.type) {
    case "SET_CATEGORY":
      return {
        ...state,
        categories: action.payload.data,
        page: action.payload.page,
        limit: action.payload.limit,
        count: action.payload.count,
      };
    case "SET_TOPIC":
      return {
        ...state,
        topics: action.payload.data,
        page: action.payload.page,
        limit: action.payload.limit,
        count: action.payload.count,
      };
    case "SET_FILE_TYPE":
      return {
        ...state,
        fileTypes: action.payload.data,
        page: action.payload.page,
        limit: action.payload.limit,
        count: action.payload.count,
      };
    default:
      return { ...state };
  }
};

export default ProductAttributesReducer;
